// extracted by mini-css-extract-plugin
export default {"gridStyle":"Styles_gridStyle__JcMKg"};